import { toast } from "react-toastify";
import "./notification.scss";

export const CreateNotification = (
  message = "Missing data in required fields",
  type = "success",
  position = "top-right",
  autoClose = 5000,
  hideProgressBar = false,
  closeOnClick = true,
  pauseOnHover = true
) => {
  switch (type) {
    case "success":
      toast.success("Step done! Next move unlocked.", {
        position,
        autoClose,
        hideProgressBar,
        closeOnClick,
        pauseOnHover,
        bodyClassName: "toastifyStyling",
      });
      break;
    case "warning":
      toast.warn(message, {
        position,
        autoClose,
        hideProgressBar,
        closeOnClick,
        pauseOnHover,
        bodyClassName: "toastifyStyling",
      });
      break;
    case "error":
      toast.error(message ? message : "Missing data in required fields", {
        position,
        autoClose,
        hideProgressBar,
        closeOnClick,
        pauseOnHover,
        bodyClassName: "toastifyStyling",
      });

      break;
    default:
      return;
  }
};
